import request from '@/http/request'

// API 调用信息汇总详情查询最近7天
export const getListApiStatusDashboardRfid = () => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-api-detail-info/list_api_status_dashboard`)
}
// API 所有类型
export const getListAllApiTypeRfid = () => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-api-detail-info/list_all_api_type`)
}
// 分页展示调用信息详情信息
export const getApiDetailInfoPageRfid = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-api-detail-info/page`, params)
}
// 导出展示调用信息详情信息excel
export const getApiDetailInfoExportRfid = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-api-detail-info/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
// 展示通道机器状态分页信息
export const getchannelMachineStatusRfid = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-channel-machine-status/page`, params)
}
// 获取最后更新时间
export const queryLastUpdateTimeRfid = () => {
  return request.get(
    `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-channel-machine-status/query_last_update_time`
  )
}
// 导出通道机器状态分页信息excel
export const channelMachineStatusExportRfid = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-channel-machine-status/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
// 展示通道最近7天信息
export const channelMachineStatusSevenDataRfid = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rfid-channel-machine-status/sevenDaysInfo`,
    params
  )
}
